'use strict';

import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {h, Fragment} from 'preact';
import ReactDOM from 'react-dom';
import Items from '../Cart/Items';
import {confirm} from '../../src/desktop/alerts';
import {initSlider} from '../../src/desktop/related-products';
import {updatePromocodeMode} from '../../src/cart-promocode';
import CartItemDesktop from './Cart/CartItemDesktop';

function Cart(props) {
    const [inited, setInited] = useState(false);
    const [basket, setBasket] = useState({items: [], total: {}});

    const count = useMemo(() => {
        return basket.items.reduce((prev, current) => {
            return prev + current.quantity;
        }, 0);
    }, [basket]);

    const totalSum = useMemo(() => {
        const sum = basket.items.reduce((prev, current) => {
            return prev + current.price * current.quantity;
        }, 0);

        return Number(sum).toFixed(2);
    }, [basket]);

    const refresh = useCallback(() => {
        $.get(
            global.config.lang === 'ru' ? '/basket/' : '/ua/basket/',
            response => {
                setBasket(response);
            },
            'json'
        );
    }, []);

    useEffect(refresh, []);

    useEffect(() => {
        if (!inited && typeof basket.isPreorder !== 'undefined') {
            setInited(true);
        }
    }, [basket]);

    if (typeof window.cartRefresh === 'undefined') {
        window.cartRefresh = refresh;
    }

    useEffect(() => {
        initSlider();
        updatePromocodeMode();
    }, [basket.items]);

    const changeTitle = useCallback(() => {
        var title1 = $('#bask_title1');
        var title2 = $('#bask_title2');

        if (title1.length <= 0 || title2.length <= 0) {
            return;
        }

        const title1Visible = title1.is(':visible');
        title1.toggle(!title1Visible);
        title2.toggle(title1Visible);

        setTimeout(changeTitle, 5 * 1000);
    }, []);

    useEffect(changeTitle, []);

    const showBuyOnlyAvailable = useMemo(() => {
        return !basket.hasPricesChanged && basket.isPreorder && basket.hasAvailableGoods;
    }, [basket]);

    const showMakePreorder = useMemo(() => {
        return !basket.hasPricesChanged && basket.isPreorder;
    }, [basket]);

    const empty = useCallback(() => {
        // Точно удалить ВЕСЬ товар из корзины?
        confirm(
            trans('cart.sure_to_clear_all'),
            () => {
                var onlyAvailable = window.location.href.indexOf('available=1') !== -1;

                $.post('/basket/delete/', {basket_id: 0, available: ~~onlyAvailable}, function (response) {
                    if (response.status !== 'success') {
                        return;
                    }

                    const newBasket = {...basket};
                    newBasket.items = [];
                    setBasket(newBasket);
                });
            },
            trans('cart.sure_to_clear_all_caption'),
            trans('cart.sure_to_clear_all_yes')
        );
    }, [basket]);

    const buyOnlyAvailable = useCallback(ev => {
        ev.preventDefault();

        oformitZakaz(true);
    }, []);

    const buy = useCallback(ev => {
        ev.preventDefault();

        oformitZakaz();
    }, []);

    const hide = useCallback(ev => {
        ev.preventDefault();

        $('.dialog_cart').hide();
    }, []);

    const refreshPrices = useCallback(ev => {
        ev.preventDefault();

        const onlyAvailable = window.location.href.indexOf('available=1') !== -1;

        $.post(
            '/basket/update_prices/',
            {available: ~~onlyAvailable},
            response => {
                if (!response || response.status !== 'success') {
                    return;
                }

                refresh();
            },
            'json'
        );
    }, []);

    return (
        <div className='block_cart' id='block-cart'>
            {/* Моя корзина */}
            <div className='caption'>
                <a rel="nofollow" href='javascript:void(0)'>{trans('cartLayout.my_basket')}</a>
            </div>

            {inited && (
                <div className='items'>
                    {/* У Вас :count */}
                    <span
                        id='bask_title1'
                        dangerouslySetInnerHTML={{
                            __html: trans('cartLayout.total_count', {
                                count:
                                    count > 0
                                        ? `${count} ${trans('cartLayout.productsPlural', count)}`
                                        : trans('cartLayout.no_items'),
                            }),
                        }}></span>

                    <span id='bask_title2' style={{display: 'none'}}>
                        {count
                            ? // На сумму :sum :currency
                              trans('cartLayout.total_sum', {
                                  sum: totalSum,
                                  currency: basket.total.symbol,
                              })
                            : // У Вас нет товаров
                              trans('cartLayout.no_items_full')}
                    </span>
                </div>
            )}

            <div className='pop_up dialog_cart'>
                <div className='pop_ar'></div>

                <div className='title'>
                    {/* Ваша корзина: */}
                    {trans('cartLayout.your_basket')}

                    {count > 0 && (
                        <div className='title2' onClick={empty}>
                            {trans('cartLayout.clear_basket')}
                        </div>
                    )}
                </div>

                <div className='clear'></div>

                <div className='scrollDiv' style={{maxHeight: basket.height + 'px'}}>
                    <Items {...{basket, setBasket, refresh}} theme={CartItemDesktop} isPopup={true} />

                    <div className='clear'></div>
                </div>

                <div className='clear'></div>

                {count > 0 && (
                    <div className='wrap_total'>
                        <div className='total_item'>
                            {/* У Вас */}
                            {trans('cartLayout.you_have')}{' '}
                            <span>{count + ' ' + trans('cartLayout.productsPlural', count)}</span>
                        </div>

                        <div className='total_price'>
                            {/* На сумму */}
                            {trans('cartLayout.your_sum')} <span>{`${totalSum} ${basket.total.symbol}`}</span>
                        </div>

                        <div className='total_action'>
                            {/* Сначала обновите цены */}
                            {basket.hasPricesChanged && (
                                <a
                                    rel="nofollow"
                                    href='javascript:void(0)'
                                    className='butBlue checkout checkout-reload'
                                    onClick={refreshPrices}>
                                    {trans('basketUpdatePrices.button')}
                                </a>
                            )}

                            {/*Купить только товары в наличии */}
                            {basket.isUa && showBuyOnlyAvailable && (
                                <a
                                    rel="nofollow"
                                    href='javascript:void(0)'
                                    className='butBlue checkout checkout-availability'
                                    onClick={buyOnlyAvailable}>
                                    {trans('cartLayout.buy_only_available')}
                                </a>
                            )}

                            {/* Оформить заказ */}
                            {!basket.hasPricesChanged && (
                                <a
                                    rel="nofollow"
                                    href='javascript:void(0)'
                                    className={
                                        'butBlue checkout ' +
                                        (basket.isPreorder ? 'checkout-preorder' : '') +
                                        ' ' +
                                        (count > 0 ? '' : 'disable')
                                    }
                                    onClick={buy}>
                                    {basket.isPreorder
                                        ? trans('cartLayout.make_preorder')
                                        : trans('cartLayout.make_order')}
                                </a>
                            )}
                        </div>
                    </div>
                )}

                {basket.featureFlagPartnership && count > 0 && (
                    <div className='promo-code-field'>
                        <p>Промокод:</p>
                        <input
                            type='text'
                            className='js-promo-code'
                            placeholder='8-ми значный код'
                            maxLength='8'
                            value={basket.promocode || ''}
                        />
                    </div>
                )}

                <div className='bot_block'>
                    {/* Продолжить покупки */}
                    <a rel="nofollow" href='javascript:void(0)' className='proceed' onClick={hide}>
                        {trans('cartLayout.continue_shopping')}
                    </a>

                    {showMakePreorder && <div className='bot_block_divider'></div>}

                    {/* Цена на товар изменилась с учетом курса доллара.<br>Пожалуйста, обновите цену */}
                    {count > 0 && basket.hasPricesChanged && (
                        <p className='bot_block_notice'>
                            <b
                                dangerouslySetInnerHTML={{
                                    __html: trans('basketUpdatePrices.tip'),
                                }}></b>
                        </p>
                    )}

                    {count > 0 && showMakePreorder && (
                        <p className='bot_block_notice'>{trans('cartLayout.preorder_disclaimer')}</p>
                    )}
                </div>

                {/*TODO*/}
                {/*@include('basket.blocks.cart_related_items')*/}
            </div>
        </div>
    );
}

if (typeof window !== 'undefined') {
    const target = document.querySelector('.js-app-cart');

    if (target) {
        ReactDOM.render(<Cart />, target);
    }
}
